/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideAnalysisResult200ResponseData } from './OverrideAnalysisResult200ResponseData';
import {
    OverrideAnalysisResult200ResponseDataFromJSON,
    OverrideAnalysisResult200ResponseDataFromJSONTyped,
    OverrideAnalysisResult200ResponseDataToJSON,
    OverrideAnalysisResult200ResponseDataToJSONTyped,
} from './OverrideAnalysisResult200ResponseData';

/**
 * 
 * @export
 * @interface GetAnalysisResultHistory200Response
 */
export interface GetAnalysisResultHistory200Response {
    /**
     * 
     */
    data?: Array<OverrideAnalysisResult200ResponseData>;
}

/**
 * Check if a given object implements the GetAnalysisResultHistory200Response interface.
 */
export function instanceOfGetAnalysisResultHistory200Response(value: object): value is GetAnalysisResultHistory200Response {
    return true;
}

export function GetAnalysisResultHistory200ResponseFromJSON(json: any): GetAnalysisResultHistory200Response {
    return GetAnalysisResultHistory200ResponseFromJSONTyped(json, false);
}

export function GetAnalysisResultHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnalysisResultHistory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OverrideAnalysisResult200ResponseDataFromJSON)),
    };
}

export function GetAnalysisResultHistory200ResponseToJSON(json: any): GetAnalysisResultHistory200Response {
    return GetAnalysisResultHistory200ResponseToJSONTyped(json, false);
}

export function GetAnalysisResultHistory200ResponseToJSONTyped(value?: GetAnalysisResultHistory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OverrideAnalysisResult200ResponseDataToJSON)),
    };
}

